import { toCsvLine } from '../shared/SkuCsvDownload.helpers';

// Same shape as the backend's orders report CSV: snake_case headers, venue name under
// "venue" and its subtitle under "location", amounts in major units with a separate
// currency column, multi-value cells joined with "; ".
const COLUMNS = ['item', 'venue', 'location', 'menus', 'categories', 'units_sold', 'orders', 'earnings', 'currency'];

// Hardcoded English like the orders CSV's status labels, and the label the table shows on screen.
const UNCATEGORIZED = 'Uncategorized';

const toCsvAmount = money => (money ? money.amount.toFixed(2) : '');

const line = venueItem =>
  toCsvLine([
    venueItem.name,
    venueItem.venueName || '',
    venueItem.venueSubtitle || '',
    venueItem.menus.join('; '),
    venueItem.categories.join('; ') || UNCATEGORIZED,
    String(venueItem.unitsSold),
    String(venueItem.ordersCount),
    toCsvAmount(venueItem.earnings),
    venueItem.earnings?.currencyCode || '',
  ]);

export const buildItemsReportCsv = items =>
  [toCsvLine(COLUMNS), ...items.flatMap(item => item.venueItems.map(line))].join('');

export const itemsReportCsvFileName = () => `items_report_${Date.now()}.csv`;
